import { Size } from '@react-three/fiber';
import { Mesh, PerspectiveCamera, Texture } from 'three';

export const getFullScreenSize = (
  camera: PerspectiveCamera,
  sceneSize: Size,
  meshPositionZ: number
) => {
  const perspectiveCamera = camera as PerspectiveCamera;
  const verticalFOV = (perspectiveCamera.fov * Math.PI) / 180;

  const aspect = sceneSize.width / sceneSize.height;
  const distance = Math.abs(camera.position.z - meshPositionZ);
  const height = 2 * Math.tan(verticalFOV / 2) * distance;
  const width = height * aspect;

  return { width, height };
};

export const WEATHER_SCREEN_PREFIX = 'weather_';

interface scaleBackgroundProps {
  mesh: Mesh;
  camera: PerspectiveCamera;
  size: Size;
  positionZ: number;
  texture: Texture;
}

export const scaleBackground = (props: scaleBackgroundProps) => {
  const { height, width } = getFullScreenSize(
    props.camera as PerspectiveCamera,
    props.size,
    props.positionZ
  );

  const textureRatio = props.texture.image.width / props.texture.image.height;
  const screenRatio = width / height;

  if (screenRatio > textureRatio) {
    props.mesh.scale.set(width, width / textureRatio, 1);
  } else {
    props.mesh.scale.set(height * textureRatio, height, 1);
  }
};
